import script from "./CycleWheel.vue?vue&type=script&setup=true&lang=js"
export * from "./CycleWheel.vue?vue&type=script&setup=true&lang=js"

import "./CycleWheel.vue?vue&type=style&index=0&id=48c196d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48c196d8"]])

export default __exports__